import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import Const from 'constants';
import BasePlayer from 'services/sports/mlb/player/player';
import Action from 'actions';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class Player extends BasePlayer {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('doublePosition');
        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            [Const.EXCLUDED_BY_ORDER_RANGE]: false,
            [Const.EXCLUDED_BY_CONFIRMED_RANGE]: false,
            grades: parseFloat(expandedPlayer.grades * 1),
            homeRunPrice: parseFloat(expandedPlayer.homeRunPrice ?? 0),
            userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            isConfirmed() {
                return expandedPlayer.confirmed === Const.MLB_PLAYER_CONFIRMED;
            },
            isExcludedByFilter() {
                return this[Const.EXCLUDED_BY_ORDER_RANGE] || this[Const.EXCLUDED_BY_CONFIRMED_RANGE];
            },
            include() {
                this.includeBy([Const.EXCLUDED_BY_ORDER_RANGE, Const.EXCLUDED_BY_CONFIRMED_RANGE]);
            },
            isPitcher() {
                return this.positionName === 'P';
            },
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
        };
    }

    afterGettingPlayers({incomingValues: {dispatch}}) {
        const {playersData} = Action.getState();
        const {
            mlbFilters,
            filters: {playerConfirmed},
        } = playersData;

        this.fillTeamsData(dispatch);

        dispatch(Action.set('HittersOrder', mlbFilters.order));
        dispatch(Action.set('PlayerConfirmedFilter', playerConfirmed));
    }
}
